var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPauseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.9998 4C10.4085 4 8.88236 4.63214 7.75715 5.75736C6.63193 6.88258 5.99979 8.4087 5.99979 10V13.586L5.29279 14.293C5.15298 14.4329 5.05777 14.611 5.0192 14.805C4.98064 14.9989 5.00044 15.2 5.07611 15.3827C5.15178 15.5654 5.27992 15.7215 5.44433 15.8314C5.60874 15.9413 5.80204 16 5.99979 16H17.9998C18.1975 16 18.3908 15.9413 18.5552 15.8314C18.7197 15.7215 18.8478 15.5654 18.9235 15.3827C18.9991 15.2 19.0189 14.9989 18.9804 14.805C18.9418 14.611 18.8466 14.4329 18.7068 14.293L17.9998 13.586V10C17.9998 8.4087 17.3676 6.88258 16.2424 5.75736C15.1172 4.63214 13.5911 4 11.9998 4V4ZM11.9998 20C11.2041 20 10.4411 19.6839 9.87847 19.1213C9.31586 18.5587 8.99979 17.7956 8.99979 17H14.9998C14.9998 17.7956 14.6837 18.5587 14.1211 19.1213C13.5585 19.6839 12.7954 20 11.9998 20Z",
  fill: "#636A7D"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 2.34185,
  height: 25.7604,
  rx: 1.17093,
  transform: "matrix(0.703742 -0.710455 0.703742 0.710455 2.50781 4.24609)",
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 2.34185,
  height: 25.7604,
  rx: 1.17093,
  transform: "matrix(0.703742 -0.710455 0.703742 0.710455 3.67188 3.07031)",
  fill: "#636A7D"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPauseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pause-icon.4de6795651cd2ce4373c06b99657cd19.svg";